/**
 * The index of what the document discloses.
 *
 * Everything this kind is: how it is made, how it is read back, what it looks
 * like on the page, and how it is edited. Nothing outside this folder needs to
 * know the kind exists.
 */

import { readBoolean } from '@/domain/json'
import { type DisclosureIndexSection } from '@/domain/section'
import DisclosureIndexBlock from '@/sections/disclosureIndex/DisclosureIndexBlock.vue'
import DisclosureIndexInspector from '@/sections/disclosureIndex/DisclosureIndexInspector.vue'
import type { SectionDefinition } from '@/sections/types'

export const disclosureIndexSection: SectionDefinition<'disclosureIndex', DisclosureIndexSection> =
  {
    kind: 'disclosureIndex',
    band: 'sustainability',

    icon: ['M3 4h3.5', 'M9 4h4', 'M3 8h3.5', 'M9 8h4', 'M3 12h3.5', 'M9 12h4'],

    create: (id, title) => ({
      id,
      kind: 'disclosureIndex',
      title,
      showTitles: true,
    }),

    read: ({ id, title, stored }) => ({
      id,
      kind: 'disclosureIndex',
      title,
      showTitles: readBoolean(stored, 'showTitles', true),
    }),

    block: DisclosureIndexBlock,
    inspector: DisclosureIndexInspector,
  }
